import initDropdown from '../utils/dropdown';

export default function initTeledeclarationTab() {
    var $resultList = document.getElementById('brdr-list');
    $resultList?.classList.add('loading');
    if ($resultList) {
        fetch(script_var.ajax_url + '?action=get_bordereaux_per_cotisant_numbers', {
            method: 'POST',
            headers: {'Content-Type': 'application/json; charset=utf-8'},
        })
            .then(response => {
                if ($resultList) {
                    $resultList.classList.remove('loading');
                }
                if (!response.ok) {
                    throw new Error('Network response was no');
                }
                return response.json();
            })
            .then(data => {
                if ($resultList) {
                    $resultList.classList.remove('loading');
                    $resultList.innerHTML = data.html;
                    initDropdown($resultList);
                }
            })
            .catch(error => {
                console.log(error);
                $resultList?.classList.remove('loading');
            });
    }
}